import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import "./banner.css";

function BannerAdd() {
    const navigate = useNavigate();

    // daftar aplikasi (bisa diubah sesuai kebutuhan project)
    const [availableApps] = useState(["inovy", "yess", "toca", "gass"]);

    const [formValue, setFormValue] = useState({
        title: "",
        apps: [],
        active: true,
        image: null,
    });

    const [preview, setPreview] = useState(null);

    // === Handle input form ===
    const handleChange = (event) => {
        const { name, value, files, type, checked } = event.target;

        if (type === "file" && files.length > 0) {
            const file = files[0];
            setFormValue({ ...formValue, image: file });

            // tampilkan preview gambar
            const reader = new FileReader();
            reader.onload = (e) => setPreview(e.target.result);
            reader.readAsDataURL(file);
        } else if (type === "checkbox" && name === "active") {
            setFormValue({ ...formValue, active: checked });
        } else if (type === "checkbox" && name.startsWith("app_")) {
            const appName = value;
            const updatedApps = checked
                ? [...formValue.apps, appName]
                : formValue.apps.filter((a) => a !== appName);
            setFormValue({ ...formValue, apps: updatedApps });
        } else {
            setFormValue({ ...formValue, [name]: value });
        }
    };

    // === Submit form ===
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formValue.title || formValue.apps.length === 0 || !formValue.image) {
            Swal.fire({
                title: "Error",
                text: "Judul, gambar, dan minimal satu aplikasi wajib diisi!",
                icon: "error",
            });
            return;
        }

        const formData = new FormData();
        formData.append("title", formValue.title);
        formData.append("apps", formValue.apps.join(",")); // ✅ FIX
        formData.append("active", formValue.active ? "1" : "0");
        formData.append("image", formValue.image);

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/banner`, formData);

            Swal.fire({
                title: "Success",
                text: "Banner berhasil ditambahkan!",
                icon: "success",
            });

            navigate("/banner");
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Error",
                text: "Terjadi kesalahan saat menambahkan banner.",
                icon: "error",
            });
        }
    };


    return (
        <div>
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Administrasi</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Tambah Banner</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Banner</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {/* Judul Banner */}
                                            <div className="form-group">
                                                <label>Judul Banner</label>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control"
                                                    placeholder="Masukkan judul banner"
                                                    value={formValue.title}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            {/* Apps Checkbox */}
                                            <div className="form-group">
                                                <label>Aplikasi Terkait</label>
                                                <div className="d-flex flex-wrap">
                                                    {availableApps.map((app) => (
                                                        <div
                                                            key={app}
                                                            className="form-check mr-3 mb-2"
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`app_${app}`}
                                                                name={`app_${app}`}
                                                                value={app}
                                                                checked={formValue.apps.includes(
                                                                    app
                                                                )}
                                                                onChange={handleChange}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`app_${app}`}
                                                            >
                                                                {app.toUpperCase()}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Upload Gambar */}
                                            <div className="form-group">
                                                <label>Gambar Banner</label>
                                                <input
                                                    type="file"
                                                    name="image"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview && (
                                                    <div className="preview-container-banner mt-3">
                                                        <img
                                                            src={preview}
                                                            alt="Preview"
                                                            className="preview-image-banner"
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {/* Status Aktif */}
                                            <div className="form-group form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="active"
                                                    name="active"
                                                    checked={formValue.active}
                                                    onChange={handleChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="active"
                                                >
                                                    Aktif
                                                </label>
                                            </div>

                                            {/* Tombol Aksi */}
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info">
                                                    Simpan
                                                </button>
                                                <Link to="/banner">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-2"
                                                    >
                                                        Batal
                                                    </button>
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default BannerAdd;
